import { useEffect } from 'react'

import { useMapsLibrary, useMap } from '@vis.gl/react-google-maps'
import { CheckpointMarker } from '../types'

export function useAutoBounds(checkpoints: CheckpointMarker[]) {
  const coresLibrary = useMapsLibrary('core')
  const map = useMap()

  useEffect(() => {
    if (!map || !coresLibrary || checkpoints.length === 0) return

    const bounds = new coresLibrary.LatLngBounds()
    checkpoints.forEach((checkpoint) => {
      const latLng = new coresLibrary.LatLng(checkpoint.coord)
      bounds.extend(latLng)
    })
    map.fitBounds(bounds)
  }, [map, coresLibrary, checkpoints])
}
